﻿import * as React from 'react';
import { NumberBox, SelectBox, } from 'devextreme-react';

export interface Props {
    id?: string;
    cid?: string;
    unitId?: string;
    hint?: string;
    placeholder?: string;
    value?: number;
    fixedUnit?: string;
    format?: string;
    showUnits?: boolean;
    uoms?: any[];
    selectedUom?: number;
    containerClass?: string;
    readOnly?: boolean;
    onAcceptButtonClick?: (e: any) => void;
    onValueChanged?: (e: any) => void;
    onUomChanged?: (e: any) => void;
}

export interface State {
    borderWidth?: number;     
}

export class NumberBoxComponent extends React.Component<Props> {
    state: State;

    constructor(props: Props) {
        super(props);

        this.valueChanged = this.valueChanged.bind(this);
        this.uomChanged = this.uomChanged.bind(this);
        this.acceptButtonClick = this.acceptButtonClick.bind(this);

        this.state = {
            borderWidth: 1
        };
    }

    render() {
        const value = this.props.value;
        const uoms = this.props.uoms ? this.props.uoms : [];
        const selectedUom = this.props.selectedUom;
        const fixedUnit = this.props.fixedUnit;
        const showUnits = this.props.showUnits ? this.props.showUnits : false;

        const format = this.props.format ? this.props.format : "#0.0000";
        const containerClass = this.props.containerClass ? this.props.containerClass : "number-box-component";

        return (
             <div className={containerClass}>
                <NumberBox id="value" className="textbox"
                    format={format} placeholder={this.props.placeholder ? this.props.placeholder : 'NA'}
                    showClearButton={true} readOnly={this.props.readOnly}
                    hint={this.props.hint}
                    value={value}
                    onValueChanged={this.valueChanged} />

                {showUnits ?
                    uoms && uoms.length === 1 ?
                        <div className="single-unit">{uoms[0].unit}</div>
                        :
                        <SelectBox id="uom" className="selectbox"
                            placeholder='uom' readOnly={this.props.readOnly}
                            displayExpr="unit"
                            valueExpr="id"
                            onSelectionChanged={this.uomChanged}
                            dataSource={uoms}
                            value={selectedUom} />
                    : ''
                }

                {fixedUnit ?
                    <div className="fixed-unit">{fixedUnit}</div> : ''
                }
            </div>
        );
    }

    acceptButtonClick(e: any) {
        e.data = { prop: this.props.id, cid: this.props.cid };

        this.setState({ borderWidth: 0 });

        if (this.props.onAcceptButtonClick)
            this.props.onAcceptButtonClick(e);
    }

    valueChanged(e: any) {
        if (e.event) {
            e.event.data = { prop: this.props.id, cid: this.props.cid };

            this.setState({ borderWidth: 0 });

            if (this.props.onValueChanged)
                this.props.onValueChanged(e);
        }
    }

    uomChanged(e: any) {
        if (e.event) 
            e.event.data = { prop: this.props.unitId };

        if (this.props.onUomChanged)
            this.props.onUomChanged(e);
    }
}

export default NumberBoxComponent;
